module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-check-fill-fdd13d31.svg";